// extracted by mini-css-extract-plugin
export default {"root":"Verify2FA_root__6LnpM"};